(function(){

  var root = document.getElementById('coResultsV1');
  if(!root) return;

  var COLORS = {
    credit:'#18A66A',
    score:'#2368D9',
    approval:'#E2A72E',
    file:'#D73A49'
  };

  var LABELS = {
    credit:'Credit Profile Strength',
    score:'Mortgage Scores',
    approval:'Application Timing',
    file:'Verification Issues'
  };

  var FINDINGS = {
    credit:{
      title:'Credit Profile Strength',
      kicker:'Lender Review Area',
      mapCopy:'Lenders review the strength behind the score, including balances, account depth, and how the profile is structured.',
      copy:'Your answers suggest lenders may focus on how balances are distributed throughout the credit profile. The score matters, but the structure behind the score matters too.',
      danger:'A file can look stronger or weaker depending on how balances are spread across accounts.',
      insight:'Two borrowers with similar scores can receive different outcomes depending on how balances are distributed.',
      melissa:'I often see borrowers focus only on the score while missing how the credit profile actually looks to a lender.',
      simulator:'credit'
    },
    score:{
      title:'Mortgage Scores',
      kicker:'Lender Review Area',
      mapCopy:'Many borrowers track one score while lenders review another. Score source can change expectations.',
      copy:'Many borrowers monitor one score while lenders review another. Your answers suggest score source deserves review before relying on it for mortgage planning.',
      danger:'Borrowers often discover score differences after beginning the mortgage process.',
      insight:'A consumer app score can look reassuring, while the score used in mortgage review tells a different story.',
      melissa:'A strong score helps, but lenders also review which score is being used and what is creating that score.',
      simulator:'score'
    },
    approval:{
      title:'Application Timing',
      kicker:'Lender Review Area',
      mapCopy:'Timing affects how much flexibility exists before applying, underwriting, or closing.',
      copy:'Your answers suggest timing may influence flexibility before lender review. Issues discovered earlier usually provide more options than issues discovered during underwriting.',
      danger:'Issues discovered during underwriting are harder to address than issues discovered before applying.',
      insight:'The closer you are to applying, the more important timing becomes.',
      melissa:'The earlier lender concerns are identified, the more room there usually is to address them in the right order.',
      simulator:'timeline'
    },
    file:{
      title:'Verification Issues',
      kicker:'Primary Lender Focus',
      mapCopy:'Verification issues are often the first thing lenders question before moving deeper into the file.',
      copy:'Based on your answers, the area most likely to trigger lender questions is verification. Before lenders review scores, balances, or loan options, they first need confidence that the information being reviewed is accurate and accessible.',
      danger:'Unknown accounts, frozen reports, identity mismatches, and reporting inconsistencies can create lender questions when timing matters most.',
      insight:'Small verification issues can slow a file exactly when timing matters.',
      melissa:'One of the most common mistakes I see is borrowers focusing on their score while overlooking reporting or verification issues lenders question first.',
      simulator:'file'
    }
  };

  function getAnswers(){
    if(window.coReportAnswers) return window.coReportAnswers;

    try{
      var stored = localStorage.getItem('coReportAnswers');
      if(stored) return JSON.parse(stored);
    }catch(e){}

    return {
      cardsWithBalances:'many',
      anyCardOver50:true,
      scoreSource:'app',
      timeline:'soon',
      fileIssues:false,
      frozenReports:false
    };
  }

  function scoreAnswers(answers){
    var scores = {
      credit:10,
      score:10,
      approval:10,
      file:10
    };

    if(answers.cardsWithBalances === 'many') scores.credit += 30;
    if(answers.cardsWithBalances === 'some') scores.credit += 18;
    if(answers.anyCardOver50) scores.credit += 25;
    if(answers.anyCardNearLimit) scores.credit += 22;
    if(answers.overLimit) scores.credit += 25;

    if(answers.scoreSource === 'app') scores.score += 25;
    if(answers.scoreSource === 'not_sure') scores.score += 22;
    if(answers.mortgageScoreKnown === false) scores.score += 18;

    if(answers.timeline === 'soon') scores.approval += 25;
    if(answers.timeline === '30_days') scores.approval += 30;
    if(answers.timeline === '90_days') scores.approval += 18;
    if(answers.preapprovalOnly) scores.approval += 15;

    if(answers.fileIssues) scores.file += 25;
    if(answers.unknownAccounts) scores.file += 28;
    if(answers.frozenReports) scores.file += 24;
    if(answers.addressIssues) scores.file += 16;

    return normalize(scores);
  }

  function normalize(scores){
    var total = Object.keys(scores).reduce(function(sum,key){
      return sum + scores[key];
    },0);

    var normalized = {};

    Object.keys(scores).forEach(function(key){
      normalized[key] = Math.round((scores[key] / total) * 100);
    });

    var diff = 100 - Object.keys(normalized).reduce(function(sum,key){
      return sum + normalized[key];
    },0);

    normalized.credit += diff;

    return normalized;
  }

  function polarToCartesian(cx, cy, r, angle){
    var rad = (angle - 90) * Math.PI / 180;
    return {
      x: cx + (r * Math.cos(rad)),
      y: cy + (r * Math.sin(rad))
    };
  }

  function donutSlicePath(cx, cy, outerR, innerR, startAngle, endAngle){
    var largeArc = endAngle - startAngle <= 180 ? 0 : 1;

    var p1 = polarToCartesian(cx, cy, outerR, startAngle);
    var p2 = polarToCartesian(cx, cy, outerR, endAngle);
    var p3 = polarToCartesian(cx, cy, innerR, endAngle);
    var p4 = polarToCartesian(cx, cy, innerR, startAngle);

    return [
      'M', p1.x, p1.y,
      'A', outerR, outerR, 0, largeArc, 1, p2.x, p2.y,
      'L', p3.x, p3.y,
      'A', innerR, innerR, 0, largeArc, 0, p4.x, p4.y,
      'Z'
    ].join(' ');
  }

  var answers = getAnswers();
  var priorities = scoreAnswers(answers);
  var orderedKeys = Object.keys(priorities).sort(function(a,b){
    return priorities[b] - priorities[a];
  });

  var activeKey = orderedKeys[0];

  function getRole(index){
    if(index === 0) return 'Primary lender focus';
    if(index === 1) return 'Secondary focus';
    return 'Supporting area';
  }

  function renderMapHero(){
    var f = FINDINGS[orderedKeys[0]];

    setText('[data-map-primary-title]', f.title);
    setText('[data-map-primary-copy]', 'Based on your answers, this is the area most likely to trigger lender questions first.');
    setText('[data-map-melissa]', f.melissa);
  }

  function renderLadder(){
    var ladder = root.querySelector('[data-attention-ladder]');
    if(!ladder) return;

    ladder.innerHTML = '';

    orderedKeys.forEach(function(key,index){
      var f = FINDINGS[key];
      var value = priorities[key];

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cor2-ladder-item' + (key === activeKey ? ' active' : '');
      btn.setAttribute('data-area', key);

      btn.innerHTML =
        '<div class="cor2-ladder-rank">' + (index + 1) + '</div>' +
        '<div>' +
          '<div class="cor2-ladder-top">' +
            '<div>' +
              '<span class="cor2-ladder-title">' + f.title + '</span>' +
              '<span class="cor2-ladder-role">' + getRole(index) + '</span>' +
            '</div>' +
            '<span class="cor2-ladder-value">' + value + '%</span>' +
          '</div>' +
          '<div class="cor2-ladder-track">' +
            '<span class="cor2-ladder-fill" style="--bar-width:' + value + '%; --fill-color:' + COLORS[key] + ';"></span>' +
          '</div>' +
          '<span class="cor2-ladder-copy">' + f.mapCopy + '</span>' +
        '</div>';

      ladder.appendChild(btn);
    });
  }

  function renderDonut(){
    var holder = root.querySelector('[data-donut-slices]');
    if(!holder) return;

    holder.innerHTML = '';

    var start = 0;

    orderedKeys.forEach(function(key){
      var value = priorities[key];
      var end = start + (value * 3.6);

      var path = document.createElementNS('http://www.w3.org/2000/svg','path');
      path.setAttribute('d', donutSlicePath(120,120,96,58,start,end));
      path.setAttribute('fill', COLORS[key]);
      path.setAttribute('class','cor2-slice' + (key === activeKey ? ' active' : ''));
      path.setAttribute('data-segment', key);

      holder.appendChild(path);
      start = end;
    });
  }

  function renderLegend(){
    var legend = root.querySelector('[data-legend]');
    if(!legend) return;

    legend.innerHTML = '';

    orderedKeys.forEach(function(key){
      var btn = document.createElement('button');
      btn.setAttribute('data-area', key);
      if(key === activeKey) btn.classList.add('active');

      btn.innerHTML =
        '<i style="background:' + COLORS[key] + '"></i>' +
        '<span>' + LABELS[key] + '</span>' +
        '<b>' + priorities[key] + '%</b>';

      legend.appendChild(btn);
    });
  }

  function show(screen){
    root.querySelectorAll('[data-screen]').forEach(function(el){
      el.classList.remove('active');
    });

    var target = root.querySelector('[data-screen="' + screen + '"]');
    if(target) target.classList.add('active');

    setTimeout(function(){
      root.scrollIntoView({behavior:'smooth',block:'start'});
    },20);
  }

  function setActive(key){
    activeKey = key;

    root.querySelectorAll('[data-segment]').forEach(function(el){
      el.classList.toggle('active', el.getAttribute('data-segment') === key);
    });

    root.querySelectorAll('[data-area]').forEach(function(el){
      el.classList.toggle('active', el.getAttribute('data-area') === key);
    });

    renderFinding(key);
  }

  function renderFinding(key){
    var f = FINDINGS[key];

    setText('[data-finding-kicker]', f.kicker);
    setText('[data-finding-title]', f.title);
    setText('[data-finding-copy]', f.copy);
    setText('[data-danger-note]', f.danger);
    setText('[data-primary-melissa]', f.melissa);
    setText('[data-key-insight]', f.insight);

    renderSimulator(f.simulator);
  }

  function setText(selector, text){
    var el = root.querySelector(selector);
    if(el) el.textContent = text;
  }

  function renderSimulator(type){
    var box = root.querySelector('[data-simulator]');
    if(!box) return;

    if(type === 'credit'){
      box.innerHTML =
        '<div class="cor2-sim-head">' +
          '<div><div class="cor2-kicker">Pressure Example</div><h3>Balance distribution matters</h3></div>' +
          '<div class="cor2-scorebox"><span data-impact>52</span><small>Lender Pressure</small></div>' +
        '</div>' +

        '<div class="cor2-stats">' +
          '<div class="cor2-stat"><small>Balance</small><strong>$8,000</strong></div>' +
          '<div class="cor2-stat"><small>Limit</small><strong>$10,000</strong></div>' +
          '<div class="cor2-stat"><small>Utilization</small><strong data-util>80%</strong></div>' +
        '</div>' +

        '<label class="cor2-slider-label"><span>Pay down amount</span><strong data-paydown>$0</strong></label>' +
        '<input class="cor2-range" data-pay-slider type="range" min="0" max="8000" step="250" value="0">' +

        '<div class="cor2-meter">' +
          '<div class="cor2-meter-top"><span>Lender pressure zone</span><strong data-pressure>High</strong></div>' +
          '<div class="cor2-meter-bar"><span class="cor2-meter-pin" data-pin>52</span></div>' +
          '<div class="cor2-meter-labels"><span>High</span><span>Moderate</span><span>Lower</span></div>' +
        '</div>' +

        '<p class="cor2-note">This is not a credit score prediction. It shows how utilization pressure changes as balances move through important ranges.</p>';

      updatePaydown();
      return;
    }

    if(type === 'score'){
      box.innerHTML =
        '<div class="cor2-sim-head">' +
          '<div><div class="cor2-kicker">Mortgage Score Reality</div><h3>The score you see may not be the score lenders use</h3></div>' +
          '<div class="cor2-scorebox"><span>!</span><small>Score Source</small></div>' +
        '</div>' +
        '<p>Mortgage lenders often review industry-specific score models. Relying on the wrong score source creates false confidence before applying.</p>' +
        '<p class="cor2-note">This does not calculate your mortgage score. It explains why score source matters.</p>';
      return;
    }

    if(type === 'timeline'){
      box.innerHTML =
        '<div class="cor2-sim-head">' +
          '<div><div class="cor2-kicker">Timing Pressure</div><h3>Issues found late are harder to address</h3></div>' +
          '<div class="cor2-scorebox"><span>90</span><small>Days</small></div>' +
        '</div>' +
        '<p>If you are applying soon, there is less time for balances, corrections, reporting updates, or lender questions before review.</p>' +
        '<p class="cor2-note">This is a timing guide, not an approval prediction.</p>';
      return;
    }

    box.innerHTML =
      '<div class="cor2-sim-head">' +
        '<div><div class="cor2-kicker">Verification Watchlist</div><h3>What lenders may question first</h3></div>' +
        '<div class="cor2-scorebox"><span>4</span><small>Checks</small></div>' +
      '</div>' +
      '<p>Review name spelling, address history, unknown accounts, bureau access, and frozen or locked reports before a lender needs to pull.</p>' +
      '<p class="cor2-note">This is an educational readiness checklist, not a credit repair service.</p>';
  }

  function updatePaydown(){
    var slider = root.querySelector('[data-pay-slider]');
    if(!slider) return;

    var pay = Number(slider.value || 0);
    var balance = 8000;
    var limit = 10000;
    var util = Math.round(((balance - pay) / limit) * 100);
    util = Math.max(0, util);

    var impact;
    var pressure;

    if(util > 75){
      impact = 52;
      pressure = 'High';
    } else if(util > 50){
      impact = 61;
      pressure = 'Elevated';
    } else if(util > 30){
      impact = 68;
      pressure = 'Moderate';
    } else if(util > 10){
      impact = 76;
      pressure = 'Lower';
    } else {
      impact = 84;
      pressure = 'Lowest';
    }

    setText('[data-paydown]', '$' + pay.toLocaleString());
    setText('[data-util]', util + '%');
    setText('[data-impact]', impact);
    setText('[data-pressure]', pressure);

    var pin = root.querySelector('[data-pin]');
    if(pin){
      pin.textContent = impact;
      pin.style.left = impact + '%';
    }
  }

  function renderAreaList(){
    var list = root.querySelector('[data-area-list]');
    if(!list) return;

    list.innerHTML = '';

    orderedKeys.forEach(function(key){
      if(key === orderedKeys[0]) return;

      var f = FINDINGS[key];

      var card = document.createElement('div');
      card.className = 'cor2-area-card';

      card.innerHTML =
        '<button type="button" data-area-card="' + key + '">' +
          '<i style="background:' + COLORS[key] + '"></i>' +
          '<strong>' + LABELS[key] + '</strong>' +
          '<b>' + priorities[key] + '%</b>' +
        '</button>' +
        '<p>' + f.danger + '</p>';

      list.appendChild(card);
    });
  }

  root.addEventListener('click', function(e){

    var go = e.target.closest('[data-go]');
    if(go){
      show(go.getAttribute('data-go'));
      return;
    }

    if(e.target.closest('[data-open-primary]')){
      setActive(orderedKeys[0]);
      show('primary');
      return;
    }

    var toggleBreakdown = e.target.closest('[data-toggle-breakdown]');
    if(toggleBreakdown){
      toggleBreakdown.closest('.cor2-breakdown').classList.toggle('open');
      toggleBreakdown.querySelector('span').textContent =
        toggleBreakdown.closest('.cor2-breakdown').classList.contains('open') ? '⌃' : '⌄';
      return;
    }

    var area = e.target.closest('[data-area]');
    if(area){
      setActive(area.getAttribute('data-area'));
      show('primary');
      return;
    }

    var segment = e.target.closest('[data-segment]');
    if(segment){
      setActive(segment.getAttribute('data-segment'));
      show('primary');
      return;
    }

    var areaCard = e.target.closest('[data-area-card]');
    if(areaCard){
      areaCard.closest('.cor2-area-card').classList.toggle('active');
      return;
    }

    var acc = e.target.closest('[data-accordion]');
    if(acc){
      acc.classList.toggle('active');
      return;
    }

  });

  root.addEventListener('input', function(e){
    if(e.target.matches('[data-pay-slider]')){
      updatePaydown();
    }
  });

  renderMapHero();
  renderLadder();
  renderDonut();
  renderLegend();
  renderAreaList();
  renderFinding(orderedKeys[0]);

})();